<template>
  <div>
  </div>
</template>

<script>

import { mapGetters } from "vuex";
import * as api from "@/api";

export default {
  components: {
  },
  computed: {
    ...mapGetters({
      webUserAuthed: 'auth/webUserAuthed',
      get_cartid_result: 'cart/get_cartid_result',
      get_cartid: 'cart/get_cartid',
      cartid_is_ready: 'cart/cartid_is_ready',
      ProductsLoaded: 'products/getLoaded',
      getAccessToken: 'auth/getAccessToken',
    })
  },
  data() {
    return {
    }
  },
  mounted() {
    this.getCartId();
  },
  watch: {
    cartid_is_ready: async function() {

      if(this.webUserAuthed) {
        this.$store.dispatch('auth/getAccount', {register_it: 0})
      }
      var productsDat = await api.getProducts({'authorization': this.getAccessToken})
      var products    = this.productsTypeChange(productsDat.data)
      this.$store.dispatch('products/setProducts',products)

      this.$store.dispatch('cart/loadShoppingCart');
      // This is the old way to load the shoppingcart, dont reactivate the code or it will load twice at app start
      // var shoppingCart  = await api.getShopingcart({'authorization': this.getAccessToken})
      // this.$store.dispatch('cart/setShoppingCart', shoppingCart)
    },
    ProductsLoaded: function () {
        this.openShopPage();
    },
  },
  methods: {
    getCartId() {
      let browserstring = "";
      let cartid        = localStorage.getItem('cartid'); // is empty on new accounts
      this.$store.dispatch('cart/checkCartId', {cartid, browserstring});
    },
    openShopPage()
    {
      this.$router.push({name: 'shop'})
    },
    productsTypeChange:(productsData)=>{
      var keys = Object.keys(productsData)
      var products = []
      keys.forEach((key,index)=>{
        if(index===Number(key))
          products.push(productsData[key])
      })
      return products
    },
  }
}

</script>

<style scoped>
@font-face {
  font-family: "Neue";
  src: local("Neue"),
  url('../assets/fonts/neue-haas-grotesk/NeueHaasDisplayBoldItalic.ttf') format("truetype");
}
.home-login{
  font-size: 18px;
  color: black;
  font-weight: 900;
}
.home-register{
  font-size: 18px;
  font-weight: 900;
  color: white;
  border: 0;
  padding: 10px 16px;
  background-color: #19911A;
  border-radius: 30px;
  text-align: center;
}
.center {
  margin: auto;
  width: 100%;
  padding: 10px;
}
.home-hero{
  background-color: #19911A;
  padding: 20px 10px;
  font-family: "Neue";
}
.home-hero h3{
  font-size: 32px;
  color: white;
  line-height: 1.4;
  font-style: italic;
}
.home-hero h4{
  font-size: 24px;
  font-weight: 900;
  color: white;
  line-height: 1.2;
}
.home-select{
  padding: 50px 0;
  font-family: "Neue";
}
.home-select p{
  font-size: 32px;
  color: black;
}
</style>


